/**
 * Starting point for non-vendor scripts.
 */
var s = {
    $doc: jQuery(document),
    $win: jQuery(window),
    $body: jQuery('body:first-of-type'),

    collapseBreakpoint: 830,  // the width at which the header nav collapses.

    readyListeners: [],
    resizeListeners: [],
    immediateResizeListeners: [],
    scrollListeners: [],
    immediateScrollListeners: [],

    resizeTimeout: function(){},
    scrollTimeout: function(){},
};


/**
* Adds the function argument to the functions that will be called on
* $('document').ready().
*/
s.callOnReady = function(func) {
    s.readyListeners.push(func);
};


/**
* Adds the function argument to the functions that will be called on
* window resize. If withoutDelay is/evaluates to true, then the function will
* be called without a delay, otherwise a small delay will be enforced before
* the call for performance reasons.
*/
s.callOnResize = function (func, withoutDelay) {
    if (withoutDelay) {
        s.immediateResizeListeners.push(func);
    } else {
        s.resizeListeners.push(func);
    }
};


/**
* Adds the function argument to the functions that will be called on
* window scroll. If withoutDelay is/evaluates to true, then the function will
* be called without a delay, otherwise a small delay will be enforced before
* the call for performance reasons.
*/
s.callOnScroll = function (func, withoutDelay) {
    if (withoutDelay) {
        s.immediateScrollListeners.push(func);
    } else {
        s.scrollListeners.push(func);
    }
};


/*
* Calls functions added with s.callOnResize on a window resize.
*/
s.resizeCalls = function () {
    if (s.resizeTimeout) {
        clearTimeout(s.resizeTimeout);
    }

    // call functions that should be called immediately.
    for (var i=0; i < s.immediateResizeListeners.length;  i++) {
        s.immediateResizeListeners[i]();
    }

    // set the delay for the rest of the functions.
    s.resizeTimeout = setTimeout(function () {
        for (var i=0; i < s.resizeListeners.length;  i++) {
            s.resizeListeners[i]();
        }
    }, 200);
};


/*
* Calls functions added with s.callOnScroll on a window scroll.
*/
s.scrollCalls = function () {
    if (s.scrollTimeout) {
        clearTimeout(s.scrollTimeout);
    }

    // call functions that should be called immediately.
    for (var i=0; i < s.immediateScrollListeners.length;  i++) {
        s.immediateScrollListeners[i]();
    }

    // set the delay for the rest of the functions.
    s.scrollTimeout = setTimeout(function () {
        for (var i=0; i < s.scrollListeners.length;  i++) {
            s.scrollListeners[i]();
        }
    }, 200);
};


/**
* The one function that needs to be called.
*/
s.init = function () {
    s.$doc.ready(function ($){
        s.bodyId = s.$body.attr('id');
        for (var i=0; i < s.readyListeners.length;  i++) {
            s.readyListeners[i]();
        }
        s.$win.on('resize', s.resizeCalls);
        s.$win.on('scroll', s.scrollCalls);
    });
};


s.showAndHideNotification = function showAndHideNotification(html, cssClass){
  window.toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-bottom-center",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "3000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
  };
  toastr[cssClass](html);
};


/**
* Enable autosize for all textareas.
*/
s.callOnReady(function autosizeTextAreas(){
  autosize(document.querySelectorAll('textarea'));
});


/**
* Activate the newsletter ajax form.
*/
s.callOnReady(function activateSubscriptionForm(){
  $('#newsletter-form').on('submit', function(e) {
    e.preventDefault();

    var self = this;
    var data = $(this).serialize();
    var target = $(this).attr('action');

    $.post(target, data, function(response) {
      $(self).find('.fields').html(response);

      // If .subscribe-thanks exists, it's a success, so hide the submit btn.
      if ($(self).find('.subscribe-thanks').length > 0) {
        $(self).find('.btn').remove();
      }
    });
  });
});
